import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const CheckYourEmail = () => {
    const location = useLocation();
    const email = location.state?.email || 'your email';
    const isResend = location.state?.resend || false;

    return (
        <div className="flex items-center justify-center min-h-screen bg-black text-white" style={{ marginTop: '-96px' }}>
            <div className="bg-black p-8 rounded-lg shadow-md w-96">
                <div className="text-center">
                    {/* Email Icon */}
                    <div className="mb-6">
                        <svg className="w-20 h-20 text-lime-400 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                    </div>

                    <h2 className="text-2xl font-semibold mb-4">Check Your Email</h2>
                    
                    <p className="text-gray-300 mb-6">
                        {isResend 
                            ? `We've sent a new verification link to ` 
                            : `We've sent a verification link to `
                        }
                        <span className="font-semibold text-white">{email}</span>
                    </p>

                    <div className="bg-gray-900 rounded-lg p-4 mb-6 text-left">
                        <p className="text-sm text-gray-300 mb-2">
                            <strong>What's next?</strong>
                        </p>
                        <ol className="text-sm text-gray-400 space-y-2 ml-4 list-decimal">
                            <li>Check your inbox for an email from NetPoints</li>
                            <li>Click the verification link in the email</li>
                            <li>Return here to log in</li>
                        </ol>
                    </div>

                    <div className="mb-6">
                        <p className="text-xs text-gray-500 mb-2">
                            ⏰ The verification link will expire in 24 hours
                        </p>
                        <p className="text-xs text-gray-500 mb-3">
                            Didn't receive the email? Check your spam folder.
                        </p>
                    </div>

                    <Link 
                        to="/login" 
                        className="inline-block w-full p-2 bg-lime-400 text-black rounded hover:bg-lime-500 transition-colors text-center"
                    >
                        Back to Login
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default CheckYourEmail;

